{
    "ComparisonTypeLabel": "Quando:",
    "ComparisonTypeOptionNone": "[Sem alarme]",
    "ComparisonTypeOptionHigherThan": "Mais alto que",
    "ComparisonTypeOptionHigherEqual": "Superior\/Igual",
    "ComparisonTypeOptionLowerThan": "Mais baixo que",
    "ComparisonTypeOptionLowerEqual": "Menor\/Igual",
    "ComparisonTypeOptionBetween": "Entre",
    "ComparisonTypeOptionEqual": "Igual",
    "ComparisonTypeOptionNotEqual": "Não igual",
    "ComparisonTypeOptionNotBetween": "Não entre",
    "ComparisonTypeValue": "Valor:",
    "ComparisonTypeAnd": "E",
    "AlarmTypeLabel": "Tipo de alarme:",
    "AlarmTypeNoSound": "[Sem som]",
    "AlarmTypeAirRaidSiren": "Sirene de ataque aéreo",
    "AlarmTypeAlarmClock": "Despertador",
    "AlarmTypeDing": "Ding",
    "AlarmTypeDoorChime": "Carrilhão da porta",
    "AlarmTypeEmergencyServices": "Serviços de emergência",
    "AlarmTypeFastenSeatBelt": "Aperte seu cinto de segurança",
    "AlarmTypeKerching": "Kerching",
    "AlarmTypePhone": "Telefone",
    "AlarmTypeQuickBleep": "Bip rápido",
    "AlarmTypeRadar": "Radar",
    "AlarmTypeSonarPing": "Sonar Ping",
    "AlarmTypeTarget": "Alvo",
    "AlarmTypeTing": "Ting",
    "AlarmTypeWarningBeep": "Aviso sonoro",
    "AlarmTypeWarningBuzzer": "Campainha de aviso",
    "AlarmRepeatTypeLabel": "Tipo de reprodução:",
    "AlarmRepeatOnce": "Uma vez",
    "AlarmRepeatSeconds": "Segundos",
    "AlarmRepeatPersistent": "Persistente",
    "AlarmRepeatRepeat": "Repetir",
    "AlarmSettingsLabel": "Valor:",
    "StatisticAlarm_SectionHeader": "Alarme Estatístico",
    "NAME": "StatisticAlarm",
    "AlarmType_Air Raid Siren": "Sirene de ataque aéreo",
    "AlarmType_Alarm Clock": "Despertador",
    "AlarmType_Barking": "Barking",
    "AlarmType_Birds": "Aves",
    "AlarmType_Cat": "Gato",
    "AlarmType_Chips": "Batatas fritas",
    "AlarmType_Coin Drop": "Queda de moeda",
    "AlarmType_Computer": "Computador",
    "AlarmType_Cow": "Vaca",
    "AlarmType_Crowd": "Multidão",
    "AlarmType_Dial Tone": "Tom de marcação",
    "AlarmType_Ding": "Ding",
    "AlarmType_Dixie Horn": "Dixie Horn",
    "AlarmType_Door Chime": "Toque de porta",
    "AlarmType_Emergency Services": "Serviços de emergência",
    "AlarmType_Fasten Seat Belt": "Apertar o cinto de segurança",
    "AlarmType_Fire Truck": "Camião de bombeiros",
    "AlarmType_Gunshot": "Tiro",
    "AlarmType_Hammer": "Martelo",
    "AlarmType_Helicopter": "Helicóptero",
    "AlarmType_Ice Cubes": "Cubos de gelo",
    "AlarmType_Kerching": "Kerching",
    "AlarmType_Laughter": "Risos",
    "AlarmType_Marbles": "Mármores",
    "AlarmType_Monkey": "Macaco",
    "AlarmType_Morse Code": "Código Morse",
    "AlarmType_Night Time": "Hora nocturna",
    "AlarmType_Owl": "Coruja",
    "AlarmType_Phone": "Telefone",
    "AlarmType_Pool": "Piscina",
    "AlarmType_Pouring Water": "Verter água",
    "AlarmType_Quick Bleep": "Bip rápido",
    "AlarmType_Radar": "Radar",
    "AlarmType_Reload": "Recarregar",
    "AlarmType_Rocks Falling": "Queda de pedras",
    "AlarmType_Rooster": "Galo",
    "AlarmType_Sawing": "Serrar",
    "AlarmType_School Bell": "Sino da escola",
    "AlarmType_Seaguls": "Seaguls",
    "AlarmType_Service Bell": "Campainha de serviço",
    "AlarmType_SMS": "SMS",
    "AlarmType_Sonar Ping": "Ping de sonar",
    "AlarmType_Splash": "Salpicos",
    "AlarmType_Steam Train": "Comboio a vapor",
    "AlarmType_Submarine": "Submarino",
    "AlarmType_Target": "Objetivo",
    "AlarmType_Thunder": "Trovão",
    "AlarmType_Ting": "Ting",
    "AlarmType_Tolling Bell": "Campainha",
    "AlarmType_Trombone": "Trombone",
    "AlarmType_Twinkle": "Cintilar",
    "AlarmType_Walking": "Andar a pé",
    "AlarmType_Whistling": "Assobio",
    "AlarmType_Warning Beep": "Aviso sonoro",
    "AlarmType_Warning Buzzer": "Sinal sonoro de aviso"
}